/* eslint-disable camelcase */
import gql from 'graphql-tag';
import { mapAddress } from '@updater-apps/move-your-stuff/utils';
import { client } from '@updater-core/lib/apollo';
import { AddressHomeSize, session } from '@updater-core/session';
import {
  dollyMove_dollyMove,
  dollyMove,
  dollyMoveVariables,
} from '@updater-core/types/generated/dollyMove';

const query = gql`
  query dollyMove($input: DollyMoveInput!) {
    dollyMove(input: $input) {
      eligible
      availableOnMoveDate
      status
      statusDate
      bookedTime
    }
  }
`;

/**
 * Hits graphql for `dollyMove`
 */
async function fetchDollyMoveQuery() {
  const response = await client.query<dollyMove, dollyMoveVariables>({
    query,
    variables: {
      input: makeVariables(),
    },
  });
  const { data } = response;
  return data.dollyMove;
}

export interface DollyGateway {
  fetchDollyMoveQuery: () => Promise<dollyMove_dollyMove>;
}

const homeSizeForDolly = (homeSize: AddressHomeSize) => {
  if (homeSize === AddressHomeSize.three_bed_plus) {
    return AddressHomeSize.four_bed_plus;
  }
  return homeSize;
};

function makeVariables() {
  const sessionState = session.getState();

  const moveId = session.selectors.currentMoveId(sessionState);
  const fromAddress = mapAddress(
    session.selectors.currentMoveFromAddress(sessionState)
  );
  const toAddress = mapAddress(
    session.selectors.currentMoveToAddress(sessionState)
  );
  const moveDate = session.selectors.currentMoveDate(sessionState);
  const fromSize = session.selectors.fromHomeSize(sessionState);
  const toSize = session.selectors.toHomeSize(sessionState);

  return {
    moveId,
    fromAddress: {
      ...fromAddress,
      homeSize: homeSizeForDolly(fromSize),
    },
    toAddress: {
      ...toAddress,
      homeSize: homeSizeForDolly(toSize),
    },
    moveDate,
    homeSize: homeSizeForDolly(fromSize),
  };
}

export default function createGateway(): DollyGateway {
  return {
    fetchDollyMoveQuery,
  };
}
